import React from 'react';

import callIcon from '@assets/icons/call.svg';
import { Table, TablePageIndicator } from '@components';
import { formatISODate } from '@utils/date';

import ActionButton from '../ActionButton';

import { callColumns, Outcome } from '../../constants/leadActivity';
import useCanEditLead from '../../hooks/useCanEditLead';
import { CallTableProps } from '../../types/leadActivity';
import { getTableColumns } from '../../utils/common';

const CallTable: React.FC<CallTableProps> = ({
  calls,
  page,
  totalCount,
  setPage,
  handleMenuIconClick
}) => {
  const canEditLead = useCanEditLead();
  const getOutcomeLabel = (outcomeId: string): string => {
    const outcome = Outcome.find((item) => item.value === outcomeId);
    return outcome ? outcome.label : outcomeId;
  };

  const tableData = calls.map((call) => ({
    id: call.id,
    type: call.call_type,
    timestamp: formatISODate({
      date: call.timestamp,
      format: 'dd-mm-yyyy',
      separator: '/'
    }),
    time: formatISODate({ date: call.timestamp, format: 'hh:mm am/pm' }),
    outcome: getOutcomeLabel(call.outcome),
    actions: (
      <ActionButton
        item={call}
        handleEditAction={(item) => handleMenuIconClick(item.id, 'edit')}
        handleDeleteAction={(item) => handleMenuIconClick(item.id, 'delete')}
        actions={canEditLead ? ['edit', 'delete'] : []}
      />
    )
  }));

  return (
    <div className="space-y-4">
      {calls.length === 0 ? (
        <div className="py-8 text-center text-gray-500">
          <img src={callIcon} alt="call" className="mx-auto mb-2" />
          <p>
            No calls logged for this lead yet. Log your first call to track
            conversations.
          </p>
        </div>
      ) : (
        <>
          <Table
            columns={getTableColumns(callColumns, canEditLead)}
            data={tableData}
            isRowClickRequired={false}
            handleSelect={() => {}}
            disabledRowIds={[]}
            className="h-fit"
          />
          {totalCount > 0 && (
            <TablePageIndicator
              currentPage={page}
              totalCount={totalCount}
              onPageChange={setPage}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CallTable;
